import { render } from "./products-images-upload-page.vue?vue&type=template&id=15d11d08&scoped=true"
import script from "./products-images-upload-page.vue?vue&type=script&lang=js"
export * from "./products-images-upload-page.vue?vue&type=script&lang=js"

import "./products-images-upload-page.vue?vue&type=style&index=0&id=15d11d08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d11d08"]])

export default __exports__